import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { KmsService } from '../../../../kms.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-imgs',
  templateUrl: './select-imgs.component.html',
  styleUrls: ['./select-imgs.component.css']
})
export class SelectImgsComponent implements OnInit {
  @ViewChild('selectImgsModal') selectImgsModal: SwModalframeComponent;
  // 输入参数
  @Input() param: any = [];
  // 抛出事件
  @Output() callback = new EventEmitter();
  imgs:any = [];
  datas:any = [];
  // 分页参数
  pageBase: any = {
    current: 1,
    size: 30
  };
  
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
    this.imgs = this.param.imgs;
    this.getData();
  }

  // 查询素材图片信息
  getData(){
    let params ={
      current: this.pageBase.current,
      size: this.pageBase.size,
      materialId: this.param.materialId
    }
    this.kmsService.queryDetailList(params).subscribe(
      data => {
          if (data.code == '200') {
              this.pageBase = data.data;
              this.datas = data.data.records ? data.data.records : [];
              if(this.datas.length>0){
                  this.datas.forEach(element => {
                      element['src'] = environment.staticFileUrl + this.getThumbnailImg(element.filePath);
                  });
              }
          } else {
              this.message.waring('素材内容信息查询失败！');
          }
      }
    );
  }

  // 分页点击方法
  clickPageQuery(event) {
    this.pageBase['pageNum'] = event.current;
    this.pageBase['pageSize'] = event.size;
    this.getData();
  }

  // 判断图片是否已选中
  isSelect(el){
    if(this.imgs.filter(item => el.detailId == item.detailId).length == 0){
      return false;
    }
    else{
      return true;
    }
  }

  selectOrCancel(el){
    // 选中
    if(this.imgs.filter(item => el.detailId == item.detailId).length == 0){
      this.imgs.push(el);
    }
    // 取消选中
    else{
      let arr = this.imgs.filter(item => el.detailId != item.detailId);
      this.imgs = JSON.parse(JSON.stringify(arr));
    }
  }

  onSubmit(){
    let datas = JSON.parse(JSON.stringify(this.imgs));
    datas = datas.sort(function (a, b) { return a.pagesNum - b.pagesNum });
    this.selectImgsModal.toggle();
    this.callback.emit(datas);
  }

  // 根据素材每页原图获取缩略图
  getThumbnailImg(path){
    if(path){
        let arr = path.split('/');
        let str = '';
        for(let i=0;i<arr.length;i++){
            if(i == arr.length - 1){
                let arr1 = arr[i].split('.');
                str += ('THUMB/'+arr1[0]+'_300@x.'+arr1[1]);
            }else{
                str += arr[i]+'/';
            }
        }
        return str;
    }else{
        return '';
    }
  }
}
